import AuftragMain from './AuftragMain';

/**
 * @author noone
 */
export default function AuftragMainWrapper() {

    return (
        <AuftragMain />
    );

}

